import posthog from 'posthog-js'
import LogRocket from 'logrocket'

export function initAnalytics() {
  LogRocket.init('qup0sp/fellowship')
  const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined
  if (!key) return
  posthog.init(key, {
    api_host: (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://us.i.posthog.com',
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: 'identified_only',
  })
}

export function track(event: string, properties?: Record<string, unknown>) {
  posthog.capture(event, properties)
}

interface IdentifyTraits {
  email?: string | null
  role?: string | null
  displayName?: string | null
}

export function identify(userId: string, properties?: IdentifyTraits) {
  posthog.identify(userId, properties ?? undefined)
  // LogRocket traits must be string | number | boolean — drop empty values.
  // It also maps the reserved `name` field rather than `displayName`.
  const traits: Record<string, string> = {}
  if (properties?.displayName) traits.name = properties.displayName
  if (properties?.email) traits.email = properties.email
  if (properties?.role) traits.role = properties.role
  LogRocket.identify(userId, traits)
}

export function reset() {
  posthog.reset()
  // LogRocket has no reset(); ending the session detaches it from the user.
  LogRocket.startNewSession()
}

export function pageView(url: string) {
  posthog.capture('$pageview', { $current_url: url })
}
